import styled from "styled-components";

import { DynamicsenrichmentBlue } from "@similarweb/icons/illustrations";

export const StyledComingSoonIllustration = styled(DynamicsenrichmentBlue)`
    width: 260px;
    height: 156px;
`;
